import * as mixpanelBrowser from "mixpanel-browser";
import { isMobile } from "mobile-device-detect";
import { CsContextApiModel } from "./api-models";
import { setCsContext } from "./services/cs-context";
import { Analytics } from "./services/analytics/analytics";
import { initializeMixpanel } from "./services/analytics/mixpanel-analytics";
import uiConfig from "./ui-config";
import { setSmartSearchDebug } from "./services/set-debug";

export default async function init(
  context: CsContextApiModel,
  uiConfigOverrides?: Partial<typeof uiConfig>,
): Promise<void> {
  // const environmentVariables: EnvironmentVariables = {
  //     SENTRY_DSN: `https://3878a87557294366be686c5683c8ead3@sentry.io/243217`,
  //     MIXPANEL_TOKEN: `260ac8b167e816786ebe6a3e2e870f78`
  // };

  // UiConfig.mixpanelToken = initializationData.environment.MIXPANEL_TOKEN;
  // UiConfig.sentryDsn = initializationData.environment.SENTRY_DSN;
  // (window as any).cs = { library: library };

  if (uiConfigOverrides) {
    Object.keys(uiConfigOverrides).forEach((key) => {
      if (uiConfigOverrides[key] !== null && uiConfigOverrides[key] !== undefined) {
        uiConfig[key] = uiConfigOverrides[key];
      }
    });
  }

  setCsContext(context);

  if (isMobile) {
    document.body.classList.add("is-mobile-device");
  }

  // Initialize the common services
  // initializeRaven(); // There is a problem with vue-imagesloaded and Raven/Sentry that needs to be resolved
  await initializeMixpanel(mixpanelBrowser);

  // Bootstrap the application using the data provided from server-side
  Analytics.identify(context.user);

  // Set debug on for gyre users
  setSmartSearchDebug(context);
}
